import { useMemo } from 'react';

import { UniverseReference } from '@front/common/src/types/commons';

import { translate } from '@front/i18n';

import { mapOptionsNameToOptionsLabelFormat } from './utils';

const t = translate('screens.professional_status');

type UseCompanyStatusProps = {
  isOptionObjectWithLabel?: boolean;
  universe: UniverseReference;
};

export const useCompanyStatus = ({ isOptionObjectWithLabel = false, universe }: UseCompanyStatusProps) => {
  const companyStatusOptions = useMemo(() => {
    const options = [
      {
        name: t('.company_status_dropdown.auto_entrepreneur'),
        value: 'auto_entrepreneur',
      },
      { name: t('.company_status_dropdown.other_entity'), value: 'other_entity' },
    ];
    if (universe === 'cleaning')
      options.push({ name: t('.company_status_dropdown.no_company'), value: 'no_company' });
    return options;
  }, [universe]);

  const formattedCompanyStatusOptions = isOptionObjectWithLabel
    ? companyStatusOptions.map(mapOptionsNameToOptionsLabelFormat)
    : companyStatusOptions;

  return formattedCompanyStatusOptions;
};
